import { Portfolio } from "./Portfolio";
import withConnect from "./withConnect";

export const PortfolioConnected = withConnect(Portfolio);
export default PortfolioConnected;
